import type { Catalog } from "./en";

export const fr: Catalog = {
  "common.retry": "Réessayer",
  "common.reload": "Recharger",
  "common.save": "Enregistrer",
  "common.saving": "Enregistrement…",
  "common.saved": "Enregistré",
  "common.saveFailed": "Échec de l'enregistrement",
  "common.saveChanges": "Enregistrer les modifications",
  "common.delete": "Supprimer",
  "common.remove": "Retirer",
  "common.cancel": "Annuler",
  "common.edit": "Modifier",
  "common.openLink": "Ouvrir",
  "common.back": "← Retour",
  "common.loading": "Chargement",
  "common.loadingMore": "Chargement…",
  "common.sending": "Envoi…",
  "common.error": "Une erreur s'est produite",
  "common.failed": "Échec",
  "common.name": "Nom",
  "common.email": "E-mail",
  "common.title": "Titre",
  "common.language": "Langue",

  "time.now": "maintenant",
  "time.lessThanMinute": "<1 min",
  "time.minutes": "{n} min",
  "time.hours": "{n} h",
  "time.days": "{n} j",

  "nav.inbox": "Boîte de réception",
  "nav.faq": "Centre d'aide",
  "nav.reports": "Rapports",
  "nav.settings": "Paramètres",
  "layout.workspace": "Espace de travail",
  "layout.newWorkspace": "+ Nouvel espace de travail",
  "layout.signOut": "Se déconnecter",

  "app.unreachable.title": "Impossible de joindre le serveur",
  "app.unreachable.body": "Vérifiez votre connexion et réessayez.",
  "app.noWorkspaces.title": "Aucun espace de travail pour l'instant",
  "app.noWorkspaces.body": "Demandez à un administrateur de vous inviter dans un espace de travail.",

  "error.pane": "Impossible d'afficher cette conversation.",
  "error.tryAgain": "Réessayer",
  "error.body": "Cet écran a rencontré une erreur inattendue.",
  "error.goInbox": "Aller à la boîte de réception",

  "login.title": "Se connecter au support",
  "login.sent": "Si {email} a accès, un lien de connexion est en route. Il expire dans 15 minutes.",
  "login.intro": "Nous vous enverrons par e-mail un lien de connexion à usage unique.",
  "login.email": "E-mail professionnel",
  "login.sendFailed": "Impossible d'envoyer le lien. Réessayez dans une minute.",
  "login.submit": "M'envoyer un lien",
  "verify.incomplete": "Ce lien est incomplet.",
  "verify.failed": "La connexion a échoué.",
  "verify.expired": "Lien expiré",
  "verify.signingIn": "Connexion en cours…",
  "verify.newLink": "Demander un nouveau lien",

  "newWs.superAdminOnly": "Seuls les super-administrateurs peuvent créer des espaces de travail.",
  "newWs.created": "Espace de travail créé",
  "newWs.copySecret": "Copiez le secret d'identité maintenant. Il n'est affiché qu'une seule fois (vous pourrez le renouveler plus tard).",
  "newWs.secretLabel": "Secret d'identité (serveur uniquement)",
  "newWs.continue": "Continuer la configuration",
  "newWs.createFailed": "Impossible de créer l'espace de travail",
  "newWs.title": "Nouvel espace de travail",
  "newWs.intro": "Un espace de travail par app ou produit. Chacun a son propre centre d'aide, sa boîte de réception et ses clés.",
  "newWs.submit": "Créer l'espace de travail",

  "reports.period": "Période",
  "reports.lastDays": "{count} derniers jours",
  "reports.loadFailed": "Impossible de charger le rapport.",
  "reports.conversations": "Conversations",
  "reports.resolved": "Résolues",
  "reports.medianReply": "Première réponse (médiane)",
  "reports.satisfaction": "Satisfaction",
  "reports.ratingsCount": "{count} notes",
  "reports.ratingsCount.one": "{count} note",
  "reports.ratingsCount.other": "{count} notes",
  "reports.ratings": "Notes",
  "reports.barLabel": "{count} notes de {score}",
  "reports.barLabel.one": "{count} note de {score}",
  "reports.barLabel.other": "{count} notes de {score}",
  "reports.recentComments": "Commentaires récents",
  "reports.noComments": "Aucun commentaire pour l'instant.",

  "status.open": "Ouvertes",
  "status.pending": "En attente",
  "status.resolved": "Résolues",

  "inbox.title": "Boîte de réception du support",
  "inbox.conversations": "Conversations",
  "inbox.liveStopped": "Les mises à jour en direct sont arrêtées.",
  "inbox.notifyPrompt": "Recevez une alerte sur le bureau pour les nouveaux messages.",
  "inbox.enableNotifications": "Activer les notifications",
  "inbox.notNow": "Plus tard",
  "inbox.statusFilter": "Statut",
  "inbox.assignee": "Assigné à",
  "inbox.all": "Toutes",
  "inbox.mine": "Les miennes",
  "inbox.unassigned": "Non assignées",
  "inbox.loadFailed": "Impossible de charger les conversations.",
  "inbox.empty.open": "Aucune conversation ouverte 🎉",
  "inbox.empty.pending": "Aucune conversation en attente 🎉",
  "inbox.empty.resolved": "Aucune conversation résolue 🎉",
  "inbox.you": "Vous",
  "inbox.agent": "Agent",
  "inbox.attachment": "📎 Pièce jointe",
  "inbox.unreadCount": "{count} non lus",
  "inbox.loadMoreFailed": "Impossible de charger plus de conversations",
  "inbox.loadMore": "Charger plus",
  "inbox.select": "Sélectionnez une conversation",
  "inbox.visitor": "Visiteur {id}",

  "contact.aria": "Contact",
  "contact.verified": "✓ Utilisateur vérifié",
  "contact.anonymous": "Visiteur anonyme",
  "contact.userId": "ID utilisateur",
  "contact.lastSeen": "Vu pour la dernière fois",
  "contact.started": "Commencée",
  "contact.rating": "Note",

  "event.resolved": "résolue",
  "event.reopened": "rouverte",
  "event.assigned": "assignée",
  "event.csat_request": "note demandée",
  "event.auto_reply": "réponse automatique",

  "sys.resolved": "Marquée comme résolue",
  "sys.reopened": "Rouverte",
  "sys.assigned": "Assignée à {name}",
  "sys.csat_request": "Note demandée",
  "sys.auto_reply": "Réponse automatique : {body}",

  "thread.aria": "Conversation",
  "thread.verified": "Utilisateur vérifié",
  "thread.you": "{name} (vous)",
  "thread.reopen": "Rouvrir",
  "thread.snooze": "Mettre en attente",
  "thread.snoozeTitle": "En attente du client",
  "thread.resolve": "Résoudre",
  "thread.liveStopped": "Les mises à jour en direct de cette conversation sont arrêtées.",
  "thread.loadFailed": "Impossible de charger cette conversation.",
  "thread.loadEarlier": "Charger les précédents",
  "thread.loadEarlierFailed": "Impossible de charger les messages précédents",
  "thread.failedRetry": "Échec : réessayer",
  "thread.typing": "{name} écrit…",
  "thread.seen": "Vu",
  "thread.updateFailed": "Échec de la mise à jour",

  "composer.uploadFailed": "Échec de l'envoi du fichier",
  "composer.savedReplies": "Réponses enregistrées",
  "composer.placeholder": "Répondre à {name}… (tapez / pour les réponses enregistrées)",
  "composer.reply": "Réponse",
  "composer.attach": "📎 Joindre",
  "composer.uploading": "Envoi du fichier…",
  "composer.removeFile": "Retirer {name}",
  "composer.send": "Envoyer",

  "faq.untitled": "(sans titre)",
  "faq.loadFailed": "Impossible de charger le centre d'aide.",
  "faq.loadFailedToast": "Impossible de charger le centre d'aide",
  "faq.notFound": "Article introuvable.",
  "faq.backToList": "Retour au centre d'aide",
  "faq.intro": "Les articles apparaissent dans le centre d'aide de l'app et sont suggérés avant que les clients ne lancent une discussion.",
  "faq.newArticle": "Nouvel article",
  "faq.categories": "Catégories",
  "faq.categoriesIntro": "Regroupez les articles par thème. Les titres sont définis par langue.",
  "faq.addCategoryFailed": "Impossible d'ajouter la catégorie",
  "faq.newCategoryPlaceholder": "Titre de la nouvelle catégorie ({locale})",
  "faq.addCategory": "Ajouter une catégorie",
  "faq.noArticles": "Aucun article pour l'instant. Commencez par votre question la plus fréquente.",
  "faq.uncategorized": "Sans catégorie",
  "faq.languages": "Langues",
  "faq.views": "Vues",
  "faq.helpful": "Utile",
  "faq.helpfulValue": "{percent} % sur {votes}",
  "faq.published": "Publié",
  "faq.draft": "Brouillon",
  "faq.missing": "Manquant",
  "faq.categoryTitle": "Titre ({locale})",
  "faq.saveCategoryFailed": "Impossible d'enregistrer la catégorie",
  "faq.categorySaved": "Catégorie enregistrée",
  "faq.deleteCategoryConfirm": "Supprimer cette catégorie ? Ses articles seront sans catégorie.",
  "faq.deleteCategoryFailed": "Impossible de supprimer la catégorie",
  "faq.addTitleFirst": "Ajoutez d'abord un titre",
  "faq.deleteArticleConfirm": "Supprimer cet article dans toutes les langues ?",
  "faq.deleteArticleFailed": "Impossible de supprimer l'article",
  "faq.category": "Catégorie",
  "faq.titlePlaceholder": "Comment puis-je… ?",
  "faq.untitledExisting": "Ajoutez un titre pour {locale}, ou retirez la traduction {locale} ci-dessous.",
  "faq.untitledNew": "Ajoutez un titre pour {locale}, ou videz le texte pour exclure cette langue.",
  "faq.slug": "Slug d'URL",
  "faq.slugHint": "Laissez vide pour le générer à partir du titre.",
  "faq.body": "Contenu (Markdown)",
  "faq.bodyHint": "Prend en charge **gras**, *italique*, listes, liens, images et `code`. Le HTML est affiché comme du texte.",
  "faq.publishedIn": "Publié en {locale}",
  "faq.removeTranslation": "Retirer la traduction {locale}",
  "faq.preview": "Aperçu",
  "faq.untitledPreview": "Sans titre",

  "settings.tab.general": "Général",
  "settings.tab.hours": "Heures d'ouverture",
  "settings.tab.install": "Installation",
  "settings.tab.push": "Notifications push",
  "settings.tab.team": "Équipe",
  "settings.tab.canned": "Réponses enregistrées",
  "settings.adminOnly": "Seuls les administrateurs de l'espace de travail peuvent modifier ces paramètres.",
  "settings.loadFailed": "Impossible de charger les paramètres.",
  "settings.reloadFailed": "Impossible de recharger les paramètres",

  "general.branding": "Image de marque",
  "general.brandingIntro": "L'apparence du centre d'aide et du chat dans votre app.",
  "general.brandColor": "Couleur de marque",
  "general.brandColorPicker": "Sélecteur de couleur de marque",
  "general.brandColorHex": "Couleur de marque en hex",
  "general.logoUrl": "URL du logo",
  "general.logoHint": "Image HTTPS affichée en haut du centre d'aide.",
  "general.languages": "Langues",
  "general.languagesIntro": "L'interface suit la langue de l'appareil lorsqu'elle est activée ici ; les articles reviennent à la langue par défaut.",
  "general.defaultLanguage": "Langue par défaut",
  "general.greeting": "Message d'accueil ({locale})",
  "general.greetingHint": "Laissez vide pour utiliser le message d'accueil intégré.",
  "general.csatTitle": "Notes de satisfaction",
  "general.csatAsk": "Demander aux clients de noter la conversation une fois résolue",

  "hours.intro": "En dehors de ces heures, les clients voient que vous êtes absent et reçoivent votre réponse automatique.",
  "hours.enable": "Utiliser des heures d'ouverture (sinon vous apparaissez toujours en ligne)",
  "hours.timezone": "Fuseau horaire",
  "hours.open": "Ouvert",
  "hours.closed": "Fermé",
  "hours.opens": "Ouverture le {day}",
  "hours.closes": "Fermeture le {day}",
  "hours.replyTitle": "Délai de réponse et réponse automatique",
  "hours.typical": "Délai de réponse habituel (minutes)",
  "hours.typicalHint": "Affiché aux clients lorsque vous êtes en ligne. Laissez vide pour le masquer.",
  "hours.away": "Message d'absence ({locale})",
  "hours.awayHint": "Envoyé automatiquement lorsque quelqu'un écrit en dehors des heures d'ouverture (au plus une fois toutes les 12 h par conversation).",

  "install.keys": "Clés",
  "install.publishableKey": "Clé publique",
  "install.publishableHint": "Peut être intégrée sans risque dans votre app et votre site.",
  "install.identitySecret": "Secret d'identité",
  "install.secretHint": "Conservez-le sur votre serveur. Il sert à signer les ID utilisateur pour lier les discussions aux utilisateurs connectés.",
  "install.secretHidden": "Masqué. Le renouveler invalide immédiatement les hashs utilisateur existants.",
  "install.rotateConfirm": "Renouveler le secret d'identité ? Votre serveur doit passer immédiatement au nouveau secret.",
  "install.rotateFailed": "Impossible de renouveler le secret",
  "install.rotate": "Renouveler le secret",
  "install.origins": "Sites autorisés",
  "install.originsIntro": "Origines autorisées à utiliser le widget web (une par ligne, p. ex. https://app.example.com). Utilisez * pour tout autoriser. Les apps mobiles n'en ont pas besoin.",
  "install.saveOrigins": "Enregistrer les origines",
  "install.reactWeb": "React (web)",
  "install.anyWebsite": "N'importe quel site",
  "install.verifyUsers": "Vérifier les utilisateurs (côté serveur)",
  "install.verifyIntro": "Calculez le hash de l'utilisateur sur votre serveur et transmettez-le avec l'ID utilisateur.",

  "push.fcmTitle": "Android (Firebase Cloud Messaging)",
  "push.fcmIntro": "Importez le JSON d'un compte de service Firebase disposant de l'autorisation Cloud Messaging.",
  "push.fcmFile": "JSON du compte de service Firebase",
  "push.saveFcm": "Enregistrer les identifiants FCM",
  "push.apnsTitle": "iOS (Apple Push Notification service)",
  "push.apnsIntro": "Créez une clé d'authentification APNs (.p8) dans votre compte développeur Apple.",
  "push.p8File": "Fichier de clé .p8",
  "push.keyId": "ID de clé",
  "push.teamId": "ID d'équipe",
  "push.saveApns": "Enregistrer les identifiants APNs",
  "push.configured": "Configuré le {date}",
  "push.notConfigured": "Non configuré",

  "team.invite": "Inviter un coéquipier",
  "team.inviteIntro": "Cette personne recevra un e-mail avec un lien de connexion.",
  "team.role": "Rôle",
  "team.role.agent": "Agent",
  "team.role.admin": "Administrateur",
  "team.sendInvite": "Envoyer l'invitation",
  "team.inviteSent": "Invitation envoyée",
  "team.inviteNoEmail": "Ajouté. Aucun e-mail envoyé : cette adresse a reçu plusieurs e-mails de connexion récemment. Elle peut utiliser l'un d'eux.",
  "team.inviteFailed": "Échec de l'invitation",
  "team.members": "Membres",
  "team.loadFailed": "Impossible de charger les membres.",
  "team.loadFailedToast": "Impossible de charger les membres",
  "team.online": "en ligne",
  "team.removeConfirm": "Retirer {name} ? Ses conversations ne seront plus assignées.",
  "team.removeFailed": "Impossible de retirer le membre",

  "canned.intro": "Tapez {shortcut} dans la zone de réponse pour en insérer une. Utilisez {name} pour le prénom du client et {agent} pour le vôtre.",
  "canned.shortcut": "Raccourci",
  "canned.shortcutHint": "lettres minuscules, chiffres, tirets",
  "canned.message": "Message",
  "canned.empty": "Aucune réponse enregistrée pour l'instant. Créez-en une, puis tapez son /raccourci dans la zone de réponse pour l'insérer.",
  "canned.new": "Nouvelle réponse enregistrée",
  "canned.deleteConfirm": "Supprimer la réponse enregistrée /{shortcut} ?",
  "canned.deleteFailed": "Impossible de supprimer la réponse enregistrée",
  "canned.loadFailed": "Impossible de charger les réponses enregistrées.",
  "canned.loadFailedToast": "Impossible de charger les réponses enregistrées",
};
